import { useState, useEffect } from "react";
import { useNavigate  } from 'react-router-dom';
import { Col, Row, Card, Button,Table, CardBody } from "react-bootstrap";
import SweetAlert2 from 'react-sweetalert2';
import apiService from '../../Auth/apiService';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import { useAuth } from "../../Auth/AuthContext";
import SeccionPageHeader from "./../Utils/SeccionPageHeader";
import CargandoSpinner from "./../Utils/CargandoSpinner";

registerLocale('es', es);
setDefaultLocale('es');

export default function PermanenciaAlbergues(){    
    const navigate = useNavigate();
    const { token, rol, sedeActual } = useAuth();
    const usrRolid = rol;
    const [cargando, setCargando] = useState(false);
    const [datoDia, setDatoDia] = useState({});
    const [ingresos, setIngresos] = useState([]);
    const [swalProps, setSwalProps] = useState({});
    const [filters, setFilters] = useState({});

    function nuevoIngreso() {
        navigate('/albergues/formularioalbergue/0');
    }

    function handleActualizar(row) {
        navigate(`/albergues/formularioalbergue/${row.familia_id}`);
    }

    function cargarDatoDia() {
        setCargando(true);
        const url = '/albergue/datodia';
        const obj = { sede: sedeActual, usrRolid: usrRolid };
        apiService.post(url, obj, token)
            .then(response => {
                if (response.status === 200) {
                    setDatoDia(response.data.datodia);
                } else {
                    setSwalProps({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo cargar el dato del día.'
                    });
                }
            })
            .catch(error => {
                console.error('Error al cargar el dato del día:', error);
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error al cargar el dato del día.'
                });
            })
            .finally(() => {
                setCargando(false);
            });
    }

    function cargarIngresos () {
        setCargando(true);
        const url = '/albergue/personasdia';
        const obj = { sede: sedeActual, usrRolid: usrRolid };
        apiService.post(url, obj, token)
            .then(response => {
                if (response.status === 200) {
                    setIngresos(response.data.personasdia);
                } else {
                    setSwalProps({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudieron cargar los ingresos.'
                    });
                }
            })
            .catch(error => {
                console.error('Error al cargar los ingresos:', error);
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error al cargar los ingresos.'
                });
            })
            .finally(() => {
                setCargando(false);
            });
    }
    function descargarPermanencia() {
        setCargando(true);
        const url = '/albergue/listadopermanencia';
        apiService.get(url, token)
            .then(response => {
                if (response.status === 200) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'permanencia_albergue.csv');
                    document.body.appendChild(link);
                    link.click();
                } else {
                    setSwalProps({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo descargar la permanencia.'
                    });
                }
            })
            .catch(error => {
                console.error('Error al descargar la permanencia:', error);
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error al descargar la permanencia.'
                });
            }
            )
            .finally(() => {
                setCargando(false);
            });
    }
    useEffect(() => {
        cargarDatoDia();
        cargarIngresos();
    }, [sedeActual, usrRolid, token]);

    const handleFilterChange = (column, value) => {
        setFilters(prev => ({
            ...prev,
            [column]: value
        }));
    };

    const filteredIngresos = ingresos.filter(row =>
        Object.entries(filters).every(([key, value]) =>
            !value ||
            String(row[key] ?? '')
                .toLowerCase()
                .includes(value.toLowerCase())
        )
    );

    return (
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Listado permanencia albergues"
                idCabezaFamilia="1"
                url={'/albergues/menualbergue'}
                nombreurl="Albergues"
                nombreform="Listado permanencia albergues"/>
            <CargandoSpinner Cargando={cargando} />
            <section className="content">
                <div className="container-fluid">
                    <Row>
                        <Col md={3}>
                            <Card className="h-100">
                                <Card.Header>Dato del día</Card.Header>
                                <Card.Body>
                                    <div>
                                        <div><strong>Familias:</strong> {datoDia.familias ?? '-'}</div>
                                        <div><strong>Personas:</strong> {datoDia.personas ?? '-'}</div>
                                    </div>
                                    <div className="d-flex justify-content-end mt-3">
                                        <Button onClick={nuevoIngreso}>
                                            NUEVA FAMILIA
                                        </Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md={3}>
                                            <Button variant="primary" className="w-100"  onClick={() => {descargarPermanencia()}}>
                                                DESCARGAR PERMANENCIA
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th>Acciones</th>
                                                <th>nro</th>
                                                {ingresos[0] &&
                                                    Object.keys(ingresos[0]).map(key => (
                                                        <th key={key}>{key}</th>
                                                    ))}
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                {ingresos[0] &&
                                                    Object.keys(ingresos[0]).map(key => (
                                                        <th key={key}>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                placeholder={`Filtro ${key}`}
                                                                value={filters[key] || ''}
                                                                onChange={e =>
                                                                    handleFilterChange(key, e.target.value)
                                                                }
                                                            />
                                                        </th>
                                                    ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredIngresos.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td>
                                                        <Button
                                                            variant="info"
                                                            size="sm"
                                                            onClick={() => handleActualizar(row)}
                                                        >
                                                            Actualizar
                                                        </Button>
                                                    </td>
                                                    <td>{idx + 1}</td>
                                                    {Object.entries(row).map(([colKey, val]) => (
                                                        <td key={colKey}>{val}</td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </CardBody>                                
                            </Card>
                        </Col>
                    </Row>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            </section>
        </div>
    );
}